import React, { createContext, useEffect, useState } from "react";

export const CameraContext = createContext();

export const CameraProvider = ({ children }) => {
  const [stream, setStream] = useState(null);
  const [permissionGranted, setPermissionGranted] = useState(null);

  useEffect(() => {
    const enableCamera = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
        setStream(mediaStream);
        setPermissionGranted(true);
      } catch (err) {
        console.error("Camera access denied:", err);
        setPermissionGranted(false);
      }
    };

    enableCamera();
  }, []);

  return (
    <CameraContext.Provider value={{ stream, permissionGranted }}>
      {children}
    </CameraContext.Provider>
  );
};
